export default __webpack_public_path__ + "static/centre-15bb53f52915a649d043f414d55868d7.jpg";